import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateItem: [],
  loading: false,
  error: null,
};

const updateItemSlice = createSlice({
  name: "updateItem",
  initialState,
  reducers: {
    fetchUpdateItemSuccess: (state, action) => {
      state.loading = false;
      state.updateItem = action.payload;
    },

    fetchUpdateItemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdateItemSuccess,
  fetchUpdateItemFailure,
} = updateItemSlice.actions;

export default updateItemSlice.reducer;